module.exports = __webpack_public_path__ + "static/img/pay-5.7dc76f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pay/pay-5.png
// module id = zQzo
// module chunks = 1